import React from 'react';
import Logo from '../../../assets/images/brand/logo-black.png';
import LogoWhite from '../../../assets/images/brand/logo-white.png';
import { useUserStore } from '../../../modules/Auth/stores/authStore';
import { IMainTemplate } from '../../models';

const LogoTemplate: React.FC<IMainTemplate> = ({ children }) => {

  const { user: meData } = useUserStore();

  return (
    <div className='flex min-h-screen flex-col'>
      <div className='fixed top-0 z-10 flex h-16 w-full items-center justify-center bg-mono-color-white shadow-level-1'>
        <img
          className=''
          src={meData?.isDarkMode ? LogoWhite : Logo}
          alt='Logo'
          width='138.09px'
          height='24px'
        />
      </div>

      <div className='mb-[70px] mt-16 min-h-[calc(100vh-4rem)] w-full bg-color-lighter md:mb-0'>
        {children}
      </div>
    </div>
  );
};

export default LogoTemplate;
